import React from 'react';
import styled from 'styled-components';
import Moment from 'react-moment';

import LinkWrap from '../link_wrap';

const BlogPostListItem = (props) => {
  const postContent = JSON.parse(props.item.content);

  return (
    <PostRow>
      <PostImage url={postContent.image.filename} />
      <PostDetails>
        <h5>
          <LinkWrap to={props.item.full_slug}>{props.item.name}</LinkWrap>
        </h5>
        <Metadata>
          <MetadataField>{props.item.field_author_string}</MetadataField>
          <MetadataField>{props.item.field_category_string}</MetadataField>
          <MetadataField>
            <Moment format="LL">{props.item.first_published_at}</Moment>
          </MetadataField>
        </Metadata>
        <div>{props.item.field_intro_string}</div>
        <LinkWrap to={props.item.full_slug}>Read More</LinkWrap>
      </PostDetails>
    </PostRow>
  );
};

const PostRow = styled.div`
  border-bottom: solid 1px #f5f5f5;
  display: flex;
  padding-top: 2rem;
  padding-bottom: 2rem;
  min-height: 20rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const PostImage = styled.div`
  background-image: url(${(props) => props.url});
  background-size: cover;
  background-position: center;
  margin: 1rem;
  width: 50%;

  @media (max-width: 768px) {
    height: 200px;
    width: 100%;
  }
`;

const Metadata = styled.div`
  padding-bottom: 0.5rem;
`;

const MetadataField = styled.span`
  padding-right: 1rem;
`;

const PostDetails = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin: 1rem;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default BlogPostListItem;
